import { initializeApp } from 'firebase/app'
import { connectAuthEmulator, getAuth } from 'firebase/auth'

export const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
}

const missing = Object.entries(firebaseConfig).filter(([, value]) => !value).map(([key]) => key)
if (missing.length > 0) {
  throw new Error(
    `Missing Firebase env vars: ${missing.join(', ')}. ` +
    'Copy .env.example to .env and fill in the values from the Firebase console.',
  )
}

export const auth = getAuth(initializeApp(firebaseConfig))

const emulator = import.meta.env.VITE_FIREBASE_AUTH_EMULATOR_HOST
if (emulator) {
  connectAuthEmulator(auth, emulator, { disableWarnings: true })
}
